var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input field js-input" }, [
    _c(
      "textarea",
      _vm._g(
        {
          staticClass: "input__el clr-blue-22 trs js-input-el",
          attrs: { id: _vm.item.id, placeholder: _vm.item.placeholder },
          domProps: { value: _vm.value },
        },
        _vm.listeners
      )
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }